import React from "react";

import "../styles/Intro.css";

import FadeInSection from "./FadeInSection";
import Lottie from 'lottie-react';
import animationData from './animation.json';


class Intro extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: true,
      activeKey: "1",
      visible: true,
    };
    this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect(eventKey) {
    this.setState({
      activeKey: eventKey,
    });
  }
  render() {
    return (
      <div id="intro">
        <span className="intro-name"> GroupMatch</span>
        <FadeInSection>
          <div className="intro-subtitle">no more awkardness on the first date </div>
          <div className="intro-desc">
          <Lottie animationData={animationData}  />
          </div>
		  <div className="introDescription">
		  Safe, Fun, Low-Pressure, Authentic and Convenient
		  </div>
          <p></p>
          
          {/* <a
            href="https://github.com/jojo142/RepairNet"
            className="intro-contact"
          >
            {"Learn More"}
          </a> &nbsp;&nbsp;&nbsp; */}
        </FadeInSection>
      </div>
    );
  }
}

export default Intro;
